module.exports = __webpack_public_path__ + "src/img/artist/artist09.jpg?bd7cf05c1a6ec53f2a5ba7b06cd59e51";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/artist09.jpg
// module id = 116
// module chunks = 0